import styled from 'styled-components';

// TODO: change height to 100% after fixing header
export const Sidebar = styled('div')`
  //height: 1200px;
  box-shadow: 0 9px 14px 2px rgba(0, 0, 0, 0.1);
  max-width: 480px;
`;
